import { ContractInfo } from 'api/types/httpsTypes/contracts';
import { ComponentProps, JSXElementConstructor } from 'react';
import {
  ExpandableCard,
  ExpandableCardContent,
  ExpandableCardTitle,
  SubCardTitle,
} from '../../components/cards';
import {
  ListItem,
  ListItemLabel,
  ListItemValue,
} from '../../research/components/shared/Common';

interface Props {
  contract: ContractInfo;
}

export type SubCardProps<
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
> = {
  as?: T;
} & ComponentProps<T>;

export const ExpandableCardAs = <
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
>({
  ...props
}: SubCardProps<T>) => {
  const Component = 'div' as any;

  return (
    <Component
      {...props}
      className="xxs:flex xxs:flex-col xxs:w-full rounded space-y-2 min-w-0 md:bg-dex-black-700  xxs:p-2 space-y-1"
    />
  );
};
export const MethodsInfo = ({ contract }: Props) => {
  return contract.methodsInfo.methods.length ? (
    <ExpandableCard
      as={ExpandableCardAs}
      expandable={true}
      defaultExpanded={false}
      size={'xs' as any}
    >
      <ExpandableCardTitle
        as={SubCardTitle}
        size="sm"
        className="flex xxs:text-base dark:text-black-50 xxs:font-normal items-center "
      >
        Methods
      </ExpandableCardTitle>
      <ExpandableCardContent>
        <ul className="flex flex-col xxs:gap-1 p-0">
          {contract.methodsInfo.methods.map((method) => (
            <ListItem
              key={method.id}
              className="xxs:flex xxs:flex-row xxs:bg-dex-black-800 xxs:p-1 xxs:rounded xxs:text-xs"
            >
              <ListItemLabel className=" xxs:text-dex-white-secondary">
                {method.name}
              </ListItemLabel>
              <ListItemValue>{method.id}</ListItemValue>
            </ListItem>
          ))}
        </ul>
      </ExpandableCardContent>
    </ExpandableCard>
  ) : (
    <></>
  );
};
